<template>
<div class="container-fluid">
    <div class="col-lg-12">
        <div class="">
            <span class="name_txt" v-if='!showAdvananced'>Enroll State</span>
            <span class="name_txt" v-if='showAdvananced'>Enrolling {{stateName}} State</span>
        </div>
        <div class="select_state" style="padding-top: 10px; margin-bottom: 20px" v-if='!showAdvananced'>
            <div class="row">
                <div class="col-md-12" style="padding: 30px">
                    <div style="padding-top: 50px; text-align: center">
                        <div style="padding-bottom: 10px">
                            <label class="name_txt2" for="States">Select States</label>
                        </div>
                        <div>
                            <select v-model="selected" class="form_select">
                                <option v-for="recipe in statestoEnroll" :value="recipe.stateCode+'_'+recipe.slug" :key="recipe.slug">
                                    {{ recipe.stateName}}
                                </option>
                            </select>
                        </div>
                        <div>
                            <button @click="moveToSetting()" class="btn_next">Next</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-if='showAdvananced' class="row">
                    <div class="col-xl-4">
                        <label>State Address* : </label>
                        <div class="form-group">
                            <textarea type="text" parsley-trigger="change" required placeholder="Enter service description" class="form-control" v-model="address"></textarea>
                        </div>
                    </div>
                    <div class="col-xl-1">
                    </div>
                </div> -->
        </div>
        <!-- <div v-if='showAdvananced'>
            {{paramUpdate}}

        </div> -->
    </div>
    <!-- CHECKS -->
    <div class="row col-xl-12" v-if='showAdvananced'>
        <div class="col-md-4">
            <div class="cardmax">
                <h4 class="header-title mt-0 mb-3" style="">Add Services</h4>
                <b-form-checkbox v-for=" (rights,index) in allServices" :key="rights.serviceId" v-model="rights.right" @change="serviceSelected(rights.serviceId,rights.right,index)" v-bind:id="rights.serviceId" class="bb"><span class="label_url">{{rights.serviceName}}</span></b-form-checkbox>
            </div>
        </div>
        <div class="col-md-4">
            <div class="cardmax">
                <h4 class="header-title mt-0 mb-3" style="">Add Documents</h4>
                <b-form-checkbox v-for=" (rights2,index) in allDocuments" :key="rights2.documentId" v-model="rights2.right" @change="documentSelected(rights2.documentId,rights2.right,index)" v-bind:id="rights2.documentId" class="bb"><span class="label_url">{{rights2.documentName}}</span></b-form-checkbox>
            </div>
        </div>
        <div class="col-md-4">
            <div class="cardmax">
                <h4 class="header-title mt-0 mb-3" style="">Add Items</h4>
                <b-form-checkbox v-for=" (rights1,index) in allItems" :key="rights1.serviceId" v-model="rights1.right" @change="itemsSelected(rights1.itemId,rights1.right,index)" v-bind:id="rights1.itemId" class="bb"> <span class="label_url"> {{rights1.itemName}} </span>
                    <div v-bind:id="'bi'+index" class="mini">
                        <br>
                        <div style="padding: 10px">
                            <label for="userName">Settlement Type : </label>
                            <!-- Settlement Type : {{rights.enabler}} - {{rights.serviceId}}<switches v-model="rights.enabler" theme="bootstrap" color="danger" v-bind:id="'ax'+rights.serviceId"></switches> -->
                            <span style="margin-right: 5px"> &#8358;</span>
                            <toggle-button v-model="enabler" @change="sttleType(rights1.itemId,enabler)" /><span style="margin-left: 5px">%</span>
                        </div>
                        <div style="padding-left: 10px">
                            <div style="margin-bottom: 10px">
                                <label for="userName">Settlement Value : </label>
                                <input type="number" n parsley-trigger="change" required placeholder="Enter value" v-model="score[index]" @change="setValue(index)" class="setvalue">
                            </div>
                        </div>
                    </div>
                </b-form-checkbox>
            </div>
        </div>
        <!-- <div class="form-group text-right mb-0 col-md-12">
            <button class="btn btn-primary waves-effect waves-light mr-1" type="submit">
                Save
            </button>
            <button type="reset" class="btn btn-secondary waves-effect waves-light">
                Cancel
            </button>
            </form>
        </div> -->
        <div class="row">
            <div class="col-lg-12">
                <div class="url_txt">
                    <div class="validation">
                        <div class="pt-4 px-10 validate_txt">
                            <h6>Validation Identifcation</h6>
                        </div>
                        <div style="padding-top: 20px" class="">
                            <!-- <label style=""></label> -->
                            <b-form-checkbox @change="showUrl == !showUrl" v-model="showUrl" class="b2"><span class="label_url" style="">Validate ID</span></b-form-checkbox>
                            <!-- <v-checkbox style="padding-top: 14px; padding-left: 15px" v-model="ValidateID" label="Validate ID" @change="!showUrl" value="ValidateID"></v-checkbox> -->
                        </div>
                        <div v-if="showUrl" class="px-10 pt-2 validate_txt">
                            <h6>Provide Url</h6>
                            <input type="text" placeholder="url">
                        </div>
                    </div>
                </div>
                <div style="margin: 20px 0" class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-4">
                        <div class="btn_class">
                            <form @submit.prevent>
                                <button class="cancel" @click="cancelSet()">Cancel</button>
                                <button class="save" @click.prevent="enrollState()">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import {
    loadProgressBar
} from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'

///////// IMPORT COOKIE SERVICE
import httpRequest from "@/services/httpRequests.js";
import cookieOps from "@/services/cookieOps.js";

/////////////////////////
import router from '@/router/index'
import Switches from 'vue-switches';

export default {
    name: 'enrol',
    components: {
        Switches
    },
    data() {
        return {
            stateName: '',
            enrolableStates: '',
            selected: 'Select State',
            statestoEnroll: '',
            showAdvananced: false,
            showUrl: false,
            allServices: '',
            allItems: '',
            rights: Array,
            enabler: '',
            address: '',
            score: [],
            paramUpdate: {
                stateCode: '',
                stateAddress: '',
                services: [],
                documents: [],
                items: [],
            },
            item: {
                //...
                image: null,
                imageUrl: null
            }
        };
    },
    watch: {
        /// watch address and add it to paramUpdate
        address(address) {
            this.paramUpdate.stateAddress = address
        },
        //watch state code/name split and  and add code to paramUpdate interpolate name on screen
        selected(selected) {
            const spliSelected = selected.split('_');
            this.stateName = spliSelected[1]
            this.paramUpdate.stateCode = spliSelected[0]
        },

        //// watch item amount as been added in settlement input and update paramUpdate
        score(score) {
            var thiss = this
            console.log(score)
            score.forEach(function (key, value) {
                console.log(value)
                thiss.paramUpdate.items.filter((v) => {
                    console.log(v);
                    if (v.key == value) {
                        v.settlementValue = key
                    }
                })
                // if(key != null){
                //          console.log(thiss.paramUpdate.services[value].settlementValue = key);
                // }
            });
        }
    },
    computed: {

    },
    beforeRouteEnter(to, from, next) {
        loadProgressBar()
        const fetch = httpRequest.get('state/getstates').then(function (res) {
            next(vm => vm.setData(res))
        })
    },
    mounted() {
        // var thiss = this
        // const fetch = httpRequest.get('state/getstates').then(function (res) {
        //     let statestoEnroll = httpRequest.detokenizeData(res.data.dataToken)
        //     statestoEnroll = statestoEnroll.data.filter((item) => {
        //         return (item.enrolledStatus == 0)
        //     })
        //     thiss.statestoEnroll = statestoEnroll
        // })
        var thiss = this
        const fetchservices = httpRequest.get('services/all').then(function (res) {
            const services = httpRequest.detokenizeData(res.data.dataToken);
            const switchEnabler = [];
            services.data.map(function (key, value) {
                key['enabler'] = 'a' + key['serviceId']
                switchEnabler['a' + key['serviceId']] = false
            });
            thiss.enabled = switchEnabler;
            thiss.allServices = services.data
        })
        ///////// get all items
        const fetchitems = httpRequest.get('item/all').then(function (res) {
            const items = httpRequest.detokenizeData(res.data.dataToken);
            const switchEnabler1 = [];
            items.data.map(function (key, value) {
                key['enabler'] = 'a' + key['serviceId']
                switchEnabler1['a' + key['serviceId']] = false
            });
            thiss.enabled = switchEnabler1;
            thiss.allItems = items.data
        })

        ///////// get all Documents
        const fetchdocs = httpRequest.get('document/get/all').then(function (res) {
            // const items = httpRequest.detokenizeData(res.data.dataToken);
            const switchEnabler2 = [];
            res.data.documents.map(function (key, value) {
                key['enabler'] = 'a' + key['documentId']
                switchEnabler2['a' + key['documentId']] = false
            });
            thiss.enabled = switchEnabler2;
            thiss.allDocuments = res.data.documents
        })
    },
    /// SCOPE METHODS
    methods: {
        setData(data) {
            let statestoEnroll = httpRequest.detokenizeData(data.data.dataToken)
            statestoEnroll = statestoEnroll.data.filter((item) => {
                return (item.enrolledStatus == 0)
            })
            this.statestoEnroll = statestoEnroll
        },
        moveToSetting() {
            this.selected != '' ? this.showAdvananced = true : ''
        },
        // moveToSetting() {
        //     this.showUrl = !this.showUrl
        // },
        serviceSelected(service, status, index) {
            console.log(status);
            //// if checkbox is selected
            if (status == true) {
                //$('#bb'+index).css("display", "inline");
                let servicesSelected = {
                    "serviceId": service,
                    "key": index
                }
                /// add to the services selected in paramUpdate
                this.paramUpdate.services.push(servicesSelected)
            } else {
                //// if checkbox is deselected remove from paramUpdate
                // $('#bb'+index).css("display", "none");
                const indexd = this.paramUpdate.services.map(function (element) {
                        return element.serviceId;
                    })
                    .indexOf(service);
                console.log(indexd);
                if (indexd > -1) {
                    this.paramUpdate.services.splice(indexd, 1);
                }
            }
            console.log(service)
            console.log(status)
        },

        documentSelected(document, status, index) {
            console.log(status);
            //// if checkbox is selected
            if (status == true) {
                //$('#bb'+index).css("display", "inline");
                let documentSelected = {
                    "documentId": document,
                    "key": index
                }
                /// add to the services selected in paramUpdate
                this.paramUpdate.documents.push(documentSelected)
            } else {
                //// if checkbox is deselected remove from paramUpdate
                // $('#bb'+index).css("display", "none");
                const indexd = this.paramUpdate.documents.map(function (element) {
                        return element.documentId;
                    })
                    .indexOf(document);
                console.log(indexd);
                if (indexd > -1) {
                    this.paramUpdate.documents.splice(indexd, 1);
                }
            }
            console.log(service)
            console.log(status)
        },
        itemsSelected(item, status, index) {
            console.log(status);
            if (status == true) {
                $('#bi' + index).css("display", "inline");
                let itemsSelected = {
                    "itemId": item,
                    "settlementType": "percent",
                    "settlementValue": "",
                    "key": index
                }
                this.paramUpdate.items.push(itemsSelected)
            } else {
                $('#bi' + index).css("display", "none");
                const indexd = this.paramUpdate.items.map(function (element) {
                        return element.itemId;
                    })
                    .indexOf(item);
                console.log(indexd);
                if (indexd > -1) {
                    //////// remove from score watch and splice from paramUpdate
                    this.score[index] = null
                    this.paramUpdate.items.splice(indexd, 1);
                }
            }
            console.log(item)
            console.log(status)
        },

        sttleType(service, status) {
            status = status == false ? 'amount' : 'percent'
            const indexd = this.paramUpdate.items.map(function (element) {
                    return element.itemId;
                })
                .indexOf(service);
            this.paramUpdate.items[indexd].settlementType = status
        },
        setValue(x) {
            console.log(x)

        },

        //////// sweet allert serivice
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },

        //THIS METHOD IS USED 
        enrollState() {
            let thiss = this
            console.log(this.paramUpdate);
            const fetch = httpRequest.post('settings/create', this.paramUpdate).then(function (res) {
                console.log(res);
                if (res.data.code == 's200') {
                    thiss.alertDisplay('Settings Saved', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Settings Not Saved', res.data.message, 'error');
                }
            })
            this.$router.push({
                path: '/enroled',
            });

        },
        cancelSet() {
            let reset = {
                stateCode: '',
                stateAddress: '',
                services: [],
                items: [],
            }
            console.log(BFormCheckbox);
            this.paramUpdate = reset
            this.showAdvananced = false
        }

    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

.url_txt {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 20px 0;
}

hr {
    border-bottom: solid 1px #ccc !important;
    margin: 0px;
}

.name_txt {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
    padding: 10px 0;
}

.btn_class {
    margin: 20px 0;
}

.name_txt2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    color: #494949;
}

.validation {
    width: 100%;
    height: auto;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 0 25px;
}

.mini2 {
    width: 287px;
    height: 239px;

    background: #F9F9F9;
    border-radius: 4px;
}

.label_url {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #494949;
    padding-left: 10px
}

h6 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 115.5%;
    display: flex;
    align-items: center;
    color: #494949;
}

input {
    width: 25%;
    height: 52px;
    background: #EEEEEE;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    border-radius: 4px;
    padding-left: 20px;
}

.check_box {
    width: 25%;
    height: 20%;
    /* margin-left: 30px; */
    background: #FFFFFF;
    box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
}

template {
    position: relative;
    min-height: 100%;
}

body {
    padding-bottom: 60px;
    overflow-x: hidden;
}

.authentication-bg.enlarged {
    min-height: 100px;
}

.cancel {
    padding: 10px;
    width: 200px;
    height: 60px;
    background: #EEEEEE;
    border-radius: 4px;
    margin-right: 20px;
    border: none;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #9A9A9A;
}

.save {
    padding: 10px;
    width: 200px;
    height: 60px;
    border: none;
    background: #555A6E;
    border-radius: 4px;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #FFFFFF;
}

.bb {
    width: 100%;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 15px 20px;
}

.b2 {
    width: 25%;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 15px 20px;
}

@media (max-width: 1000px) {
    .b2 {
        width: 100%;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        margin-bottom: 10px;
        padding: 15px 20px;
    }
}

.form_select {
    width: 25%;
    height: 60px;
    /* background: #fff; */
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    border-radius: 4px;
}

@media (max-width: 1000px) {
    .form_select {
        width: 100%;
        height: 60px;
        /* background: #fff; */
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        border-radius: 4px;
    }
}

body.authentication-bg {
    background-image: url(../../assets/bg-light-img.jpg);
    background-size: cover;
    background-position: center;
}

.mini {
    display: none;
}

.header-title {
    font-weight: 600;
    font-size: 15px;
    background: #FFF1F1;
    padding: 10px;
    color: #555A6E;

    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 115.5%;
}

.bi span {
    color: #999;
    font-size: 15px;
    margin-left: 5px
}

.btn_next {
    padding: 20px;
    width: 25%;
    height: 60px;
    border: none;
    margin-top: 20px;
    background: #555A6E;
    border-radius: 4px;
    color: #fff;
}

@media (max-width: 1000px) {
    .btn_next {
        padding: 20px;
        width: 100%;
        height: 60px;
        border: none;
        margin-top: 20px;
        background: #555A6E;
        border-radius: 4px;
        color: #fff;
    }
}

.cardmax {
    margin-top: 20px;
    width: 100%;
    height: auto;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 30px;
}

.setvalue {
    margin-left: 5px;
    border: solid 1px #ccc;
    color: #999;
    border-radius: 2px;
    padding-left: 4px;
    width: 50%;
}

.select_state {
    width: 100%;
    height: 400px;
    background: #FFFFFF;
    border-radius: 10px;

}
</style>
